<template>
<div>
  <user-form userType="SRC"/>
  
</div>
</template>
<script>
import UserForm from '../components/UserForm';

export default {
  name: 'NewUser',
  components: { UserForm},
};
</script>
